import React from "react";
import { Typography, Divider, Card } from "antd";
import styled from "styled-components";
import { useMediaQuery } from "../utils/mediaQueries";

const { Title, Paragraph } = Typography;

const PageWrapper = styled.div`
  width: 80vw;
  background-color: #fff;
  margin: auto;

  @media (max-width: 1100px) {
    width: 100vw;
  }
`;

const PageContainer = styled.div`
  padding: 30px;
  width: 100%;
  margin: auto;
`;

const PageTitle = styled(Title)`
  color: #1890ff;
  margin-bottom: 24px;
`;

const PropertyContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PropertyImage = styled.img`
  margin: auto;
  width: 100%;
`;

const PropertyEvaluationPage = () => {
  return (
    <PageWrapper>
      <PageContainer>
        <PageTitle level={2}>
          Bagaimana untuk Memeriksa Nilai Hartanah Anda di Pasaran Malaysia
        </PageTitle>
        <Divider />
        <PropertyContainer>
          <PropertyImage
            src="https://images.pexels.com/photos/8370752/pexels-photo-8370752.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            alt="Property"
          />
        </PropertyContainer>
        <Title level={3}>Pengenalan</Title>
        <Paragraph>
          Memeriksa nilai hartanah anda adalah penting untuk pelbagai sebab.
          Sama ada anda merancang untuk menjual, membeli, atau melabur,
          mempunyai penilaian yang tepat boleh memandu keputusan anda dengan
          berkesan. Di pasaran Malaysia, nilai hartanah dipengaruhi oleh faktor
          seperti lokasi, saiz, keadaan, kemudahan, dan trend pasaran.
        </Paragraph>
        <Title level={3}>Langkah-langkah untuk Menilai Hartanah Anda</Title>
        <Paragraph>
          1. Kajian dan Analisis Pasaran: Mula dengan membuat kajian dan
          mengumpulkan maklumat tentang hartanah anda dan kawasan sekelilingnya.
          Pertimbangkan faktor-faktor seperti kemudahan berdekatan, kemudahan
          pengangkutan, sekolah, dan pusat komersial. Selain itu, analisis data
          jualan terkini hartanah serupa di kawasan tersebut untuk menilai trend
          pasaran.
          <br />
          <br />
          2. Mendapatkan Bantuan Profesional: Carilah bimbingan daripada penilai
          profesional atau ejen hartanah yang mempunyai kepakaran dalam pasaran
          tempatan. Mereka boleh memberikan penilaian yang tepat berdasarkan
          pengetahuan dan pengalaman mereka.
          <br />
          <br />
          3. Alat Penilaian Hartanah dalam Talian: Gunakan alat penilaian
          hartanah dalam talian yang direka khusus untuk pasaran Malaysia.
          Alat-alat ini mengambil kira pelbagai faktor seperti lokasi, jenis
          hartanah, saiz, dan keadaan pasaran semasa untuk memberikan anggaran
          nilai hartanah anda.
          <br />
          <br />
          4. Analisis Pasaran Perbandingan: Terokai laman web penyenaraian
          hartanah dan perhatikan harga hartanah serupa di kawasan anda.
          Analisis ini akan memberikan pemahaman yang lebih baik tentang kadar
          pasaran semasa dan bagaimana hartanah anda dibandingkan dengan yang
          lain.
          <br />
          <br />
          5. Pemeriksaan Fizikal dan Ciri Hartanah: Lakukan pemeriksaan fizikal
          yang teliti terhadap hartanah anda. Catatkan keadaannya, sebarang
          pembaharuan atau peningkatan, ciri-ciri unik jualan, dan faktor-faktor
          lain yang boleh mempengaruhi nilai hartanah. Faktor-faktor ini
          termasuk bilangan bilik tidur, bilik air, tempat letak kereta, luas
          binaan, dan reka bentuk keseluruhan.
          <br />
          <br />
          6. Keadaan Pasaran dan Faktor Ekonomi: Mengetahui keadaan pasaran
          semasa adalah penting kerana ia boleh mempengaruhi nilai hartanah.
          Faktor-faktor seperti trend ekonomi, dasar kerajaan, pembangunan
          infrastruktur, dan perubahan demografi boleh memberi impak kepada
          permintaan dan nilai hartanah di pasaran.
          <br />
          <br />
          7. Penilaian Profesional: Untuk penilaian hartanah yang menyeluruh dan
          tepat, pertimbangkan untuk melibatkan penilai yang berlesen. Mereka
          akan menilai hartanah anda berdasarkan ciri-ciri tertentu, keadaan
          pasaran, dan data jualan terkini. Penilaian profesional memberikan
          analisis mendalam dan anggaran yang boleh dipercayai terhadap nilai
          hartanah anda di pasaran semasa.
          <br />
          <br />
          <br />
          Diatas hanyalah perkara-perkara asas yang anda perlu tahu dalam
          penilaian hartanah. Untuk tahu lebih lanjut dan mendalam, hubungi
          kami.
        </Paragraph>
      </PageContainer>
    </PageWrapper>
  );
};

export default PropertyEvaluationPage;
